var map = {
	"./#008000.png": "./src/components/img/poligono/#008000.png",
	"./#0277bd.png": "./src/components/img/poligono/#0277bd.png",
	"./#12db1c.png": "./src/components/img/poligono/#12db1c.png",
	"./#3546e6.png": "./src/components/img/poligono/#3546e6.png",
	"./#4b9f4a.png": "./src/components/img/poligono/#4b9f4a.png",
	"./#ED4145.png": "./src/components/img/poligono/#ED4145.png",
	"./#FFA500.png": "./src/components/img/poligono/#FFA500.png",
	"./#FFFF00.png": "./src/components/img/poligono/#FFFF00.png",
	"./#bc1fdb.png": "./src/components/img/poligono/#bc1fdb.png",
	"./#db1d0f.png": "./src/components/img/poligono/#db1d0f.png",
	"./#eb78e9.png": "./src/components/img/poligono/#eb78e9.png",
	"./#ed8515.png": "./src/components/img/poligono/#ed8515.png",
	"./#ef4a33.png": "./src/components/img/poligono/#ef4a33.png",
	"./#fdd36e.png": "./src/components/img/poligono/#fdd36e.png",
	"./danger.png": "./src/components/img/poligono/danger.png",
	"./dark.png": "./src/components/img/poligono/dark.png",
	"./ic_flag_blue.png": "./src/components/img/poligono/ic_flag_blue.png",
	"./ic_flag_green.png": "./src/components/img/poligono/ic_flag_green.png",
	"./ic_flag_grey.png": "./src/components/img/poligono/ic_flag_grey.png",
	"./ic_flag_orange.png": "./src/components/img/poligono/ic_flag_orange.png",
	"./ic_flag_red.png": "./src/components/img/poligono/ic_flag_red.png",
	"./ic_flag_yellow.png": "./src/components/img/poligono/ic_flag_yellow.png",
	"./info.png": "./src/components/img/poligono/info.png",
	"./light.png": "./src/components/img/poligono/light.png",
	"./primary.png": "./src/components/img/poligono/primary.png",
	"./success.png": "./src/components/img/poligono/success.png",
	"./warning.png": "./src/components/img/poligono/warning.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/img/poligono sync recursive ^\\.\\/.*\\.png$";